const YOUTUBE_ID_PATTERN = /^[\w-]{11}$/;

const extractYouTubeVideoId = (value: string): string | null => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return null;
  }

  if (YOUTUBE_ID_PATTERN.test(trimmedValue)) {
    return trimmedValue;
  }

  try {
    const parsedUrl = new URL(trimmedValue);
    const host = parsedUrl.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      const shortId = parsedUrl.pathname.split('/').filter(Boolean)[0] ?? '';
      return YOUTUBE_ID_PATTERN.test(shortId) ? shortId : null;
    }

    if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      const pathParts = parsedUrl.pathname.split('/').filter(Boolean);

      if (pathParts[0] === 'embed' || pathParts[0] === 'shorts' || pathParts[0] === 'live' || pathParts[0] === 'v') {
        const pathId = pathParts[1] ?? '';
        return YOUTUBE_ID_PATTERN.test(pathId) ? pathId : null;
      }

      const queryId = parsedUrl.searchParams.get('v') ?? '';
      return YOUTUBE_ID_PATTERN.test(queryId) ? queryId : null;
    }
  } catch {
    return null;
  }

  return null;
};

export const toYouTubeEmbedUrl = (value?: string | null): string | null => {
  const videoId = extractYouTubeVideoId(value ?? '');

  if (!videoId) {
    return null;
  }

  return `https://www.youtube.com/embed/${videoId}`;
};
